/* eslint-disable camelcase */
// 多事项步骤条 + 材料清单列表
import request from "../base";

/** 表单渲染(JSON模式) 表单渲染(JSON模式) */
export async function formRenderUsingGet(params) {
  return request({
    url: `/form/batchFormRender`,
    method: `GET`,
    params,
  });
}

/** 事项商城表单，材料清单弹窗 */
export async function batchMaterialListUsingGet(params) {
  return request({
    url: `/api/reception/batchRecept/execute`,
    method: `POST`,
    data: {
      ...params,
      actionCode: "BatchMaterialList",
      viewId: "BatchForm",
    },
  });
}
